import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import DeliveryFlow from 'components/DeliveryFlow';
import Gulch from 'components/Gulch';
import Dispensers from 'components/Dispensers';
import Backgrounder from 'components/Backgrounder';
import { isAcquisitionDomain } from 'utils/domainHelper';
import { getPageSlugKey } from 'utils/contentfulUtils';
import Products from './Products';
import DeliveryService from './DeliveryService';
import CallBanner from './CallBanner';
import MainBanner from './MainBanner';
import Benefits from './Benefits';
import { selectLandingData } from '../selectors';
import { fetchPromotionLandingData, navigateZipRedirect } from '../actions';
import styles from './promotionLandingPage.scss';

export const CONTENT_KEYS = {
  deliveryFlow: 'Delivery Flow',
  dispensers: 'Dispensers',
  deliveryService: 'Delivery Service',
  products: 'Products',
  benefits: 'Benefits',
  mainBanner: 'Main Banner',
  callBanner: 'Call Banner',
};

const PromotionLandingPage = ({ content, location, match: { params } }) => {
  const site = useSelector(selectLandingData());
  const dispatch = useDispatch();

  useEffect(() => {
    const currentPageSlug = get(site, 'ssrReqRoute.params[0]');
    const section = get(site, 'section', 'home');
    let path = '';
    if (params.lang) {
      path = location.pathname.replace(`/${params.lang}`, '').slice(1);
    } else {
      path = location.pathname.slice(1);
    }
    if (
      isAcquisitionDomain() &&
      currentPageSlug !== getPageSlugKey(path, section)
    ) {
      dispatch(fetchPromotionLandingData({ path }));
    }
  }, []);

  const ctaClick = (e) => {
    e.preventDefault();
    // adds promo to cart & redirects to quickshop
    dispatch(navigateZipRedirect({ stay: false }));
  };

  return (
    <div className={styles.promotionLandingPage}>
      <CallBanner content={content.callBanner} />
      <MainBanner content={content.mainBanner} />
      <DeliveryFlow
        content={content.deliveryFlow}
        className={styles.deliveryFlow}
        ctaClick={ctaClick}
      />
      <Gulch />
      <Benefits content={content.benefits} />
      <DeliveryService content={content.deliveryService} ctaClick={ctaClick} />
      <Products content={content.products} ctaClick={ctaClick} />
      <Backgrounder>
        <Dispensers content={content.dispensers} />
      </Backgrounder>
    </div>
  );
};

export default PromotionLandingPage;
